import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { applyBranding } from "@/lib/branding";

const BrandingContext = createContext(null);

export const BrandingProvider = ({ children }) => {
  const [styling, setStyling] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/app-styling");
      setStyling(data);
      applyBranding(data);
    } catch {
      setStyling(null);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const preview = useCallback((s) => applyBranding(s), []);

  return (
    <BrandingContext.Provider value={{ styling, refresh, preview, setStyling }}>{children}</BrandingContext.Provider>
  );
};

export const useBranding = () => useContext(BrandingContext);
